export const countryCodeToName: Record<string, string> = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AR: "Argentina",
  AM: "Armenia",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herz.",
  BW: "Botswana",
  BR: "Brazil",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cabo Verde",
  CF: "Central African Rep.",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Dem. Rep. Congo",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czechia",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Eq. Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "eSwatini",
  ET: "Ethiopia",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GR: "Greece",
  GD: "Grenada",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Is.",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Mexico",
  FM: "Micronesia",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PL: "Poland",
  PT: "Portugal",
  QA: "Qatar",
  RO: "Romania",
  RU: "Russia",
  RW: "Rwanda",
  KN: "St. Kitts and Nevis",
  LC: "Saint Lucia",
  VC: "St. Vin. and Gren.",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Is.",
  SO: "Somalia",
  ZA: "South Africa",
  KR: "South Korea",
  SS: "S. Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VA: "Vatican",
  VE: "Venezuela",
  VN: "Vietnam",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  MK: "Macedonia",
  PS: "Palestine",
  EH: "W. Sahara",
  NC: "N. Cyprus",
  CI: "Côte d'Ivoire",
  KP: "North Korea",
  PR: "Puerto Rico",
  DO: "Dominican Rep.",
  AG: "Antigua and Barb.",
  1: "Falkland Is.",
  2: "Antarctica",
  3: "Fr. S. Antarctic Lands",
  4: "Greenland",
  5: "Faeroe Is.",
  6: "S. Geo. and the Is.",
  7: "New Caledonia",
  8: "N. Mariana Is.",
};

export const countryNameToCode: Record<string, string> = Object.fromEntries(
  Object.entries(countryCodeToName).map(([code, name]) => [name, code]),
);

export const countryCodeToNameBG: Record<string, string> = {
  AF: "Афганистан",
  AL: "Албания",
  DZ: "Алжир",
  AD: "Андора",
  AO: "Ангола",
  AR: "Аржентина",
  AM: "Армения",
  AU: "Австралия",
  AT: "Австрия",
  AZ: "Азербайджан",
  BS: "Бахамски острови",
  BH: "Бахрейн",
  BD: "Бангладеш",
  BB: "Барбадос",
  BY: "Беларус",
  BE: "Белгия",
  BZ: "Белиз",
  BJ: "Бенин",
  BT: "Бутан",
  BO: "Боливия",
  BA: "Босна и Херцеговина",
  BW: "Ботсвана",
  BR: "Бразилия",
  BN: "Бруней",
  BG: "България",
  BF: "Буркина Фасо",
  BI: "Бурунди",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  CV: "Кабо Верде",
  CF: "Централноафриканска република",
  TD: "Чад",
  CL: "Чили",
  CN: "Китай",
  CO: "Колумбия",
  KM: "Коморски острови",
  CG: "Конго",
  CD: "Демократична република Конго",
  CR: "Коста Рика",
  HR: "Хърватия",
  CU: "Куба",
  CY: "Кипър",
  CZ: "Чехия",
  DK: "Дания",
  DJ: "Джибути",
  DM: "Доминика",
  EC: "Еквадор",
  EG: "Египет",
  SV: "Ел Салвадор",
  GQ: "Екваториална Гвинея",
  ER: "Еритрея",
  EE: "Естония",
  SZ: "Есватини",
  ET: "Етиопия",
  FJ: "Фиджи",
  FI: "Финландия",
  FR: "Франция",
  GA: "Габон",
  GM: "Гамбия",
  GE: "Грузия",
  DE: "Германия",
  GH: "Гана",
  GR: "Гърция",
  GD: "Гренада",
  GT: "Гватемала",
  GN: "Гвинея",
  GW: "Гвинея-Бисау",
  GY: "Гвиана",
  HT: "Хаити",
  HN: "Хондурас",
  HU: "Унгария",
  IS: "Исландия",
  IN: "Индия",
  ID: "Индонезия",
  IR: "Иран",
  IQ: "Ирак",
  IE: "Ирландия",
  IL: "Израел",
  IT: "Италия",
  JM: "Ямайка",
  JP: "Япония",
  JO: "Йордания",
  KZ: "Казахстан",
  KE: "Кения",
  KI: "Кирибати",
  XK: "Косово",
  KW: "Кувейт",
  KG: "Киргизстан",
  LA: "Лаос",
  LV: "Латвия",
  LB: "Ливан",
  LS: "Лесото",
  LR: "Либерия",
  LY: "Либия",
  LI: "Лихтенщайн",
  LT: "Литва",
  LU: "Люксембург",
  MG: "Мадагаскар",
  MW: "Малави",
  MY: "Малайзия",
  MV: "Малдиви",
  ML: "Мали",
  MT: "Малта",
  MH: "Маршалови острови",
  MR: "Мавритания",
  MU: "Мавриций",
  MX: "Мексико",
  FM: "Микронезия",
  MD: "Молдова",
  MC: "Монако",
  MN: "Монголия",
  ME: "Черна гора",
  MA: "Мароко",
  MZ: "Мозамбик",
  MM: "Мианмар",
  NA: "Намибия",
  NR: "Науру",
  NP: "Непал",
  NL: "Нидерландия",
  NZ: "Нова Зеландия",
  NI: "Никарагуа",
  NE: "Нигер",
  NG: "Нигерия",
  NO: "Норвегия",
  OM: "Оман",
  PK: "Пакистан",
  PW: "Палау",
  PA: "Панама",
  PG: "Папуа – Нова Гвинея",
  PY: "Парагвай",
  PE: "Перу",
  PH: "Филипини",
  PL: "Полша",
  PT: "Португалия",
  QA: "Катар",
  RO: "Румъния",
  RU: "Русия",
  RW: "Руанда",
  KN: "Свети Кристофер и Невис",
  LC: "Света Лусия",
  VC: "Сейнт Винсент и Гренадини",
  WS: "Самоа",
  SM: "Сан Марино",
  ST: "Сао Томе и Принсипи",
  SA: "Саудитска Арабия",
  SN: "Сенегал",
  RS: "Сърбия",
  SC: "Сейшелски острови",
  SL: "Сиера Леоне",
  SG: "Сингапур",
  SK: "Словакия",
  SI: "Словения",
  SB: "Соломонови острови",
  SO: "Сомалия",
  ZA: "Южна Африка",
  KR: "Южна Корея",
  SS: "Южен Судан",
  ES: "Испания",
  LK: "Шри Ланка",
  SD: "Судан",
  SR: "Суринам",
  SE: "Швеция",
  CH: "Швейцария",
  SY: "Сирия",
  TW: "Тайван",
  TJ: "Таджикистан",
  TZ: "Танзания",
  TH: "Тайланд",
  TL: "Тимор-Лесте",
  TG: "Того",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TN: "Тунис",
  TR: "Турция",
  TM: "Туркменистан",
  UG: "Уганда",
  UA: "Украйна",
  AE: "Обединени арабски емирства",
  GB: "Великобритания",
  US: "Съединени щати",
  UY: "Уругвай",
  UZ: "Узбекистан",
  VU: "Вануату",
  VA: "Ватикан",
  VE: "Венецуела",
  VN: "Виетнам",
  YE: "Йемен",
  ZM: "Замбия",
  ZW: "Зимбабве",
  MK: "Северна Македония",
  PS: "Палестина",
  EH: "Западна Сахара",
  NC: "Северен Кипър",
  CI: "Кот д’Ивоар",
  KP: "Северна Корея",
  PR: "Пуерто Рико",
  DO: "Доминиканска република",
  AG: "Антигуа и Барбуда",
  1: "Фолкландски острови",
  2: "Антарктика",
  3: "Френски Южни Антарктически острови",
  4: "Гренландия",
  5: "Фарьорски острови",
  6: "Острови Южна Джорджия и Южен Сандвич",
  7: "Нова Каледония",
  8: "Северни Мариански острови",
};
